module.exports = __webpack_public_path__ + "static/media/porte-bagage.ef9816e3.jpg";